import { Component } from '@angular/core';
import { LoaderService } from "../../providers/loader.service";

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {

  loading: boolean = false;
  message: string | null = null;

  loading$ = this.loaderService.isLoading;
  message$ = this.loaderService.message;
  

  constructor(private loaderService: LoaderService) {}
}
